import { FiAlertTriangle } from 'react-icons/fi';
import DateField from '../../../molecules/DateField';
import CurrencyInput from '../../../molecules/CurrencyInput';
import { getErrorMessage } from '../../../../utils/formErrorUtils';
import type { ErrorField } from '../../../../types/ErrorField';
import useLegalCaseWithdrawalForm, {
    residualWithdrawalErrors,
} from '../../../../hooks/useLegalCaseWithdrawalForm';
import type { UpdateJudicialDepositPayload } from '../../../../types/LegalCase';

interface LegalCaseWithdrawalFormProps {
    errorFields: ErrorField[];
    isSaving: boolean;
    onSubmit: (value: UpdateJudicialDepositPayload) => Promise<boolean>;
    onCancel: () => void;
}

// Formulário de levantamento (edita o depósito com valor + data do alvará). Valor e data andam
// juntos — a coerência é validada no backend. Só JSX + bindings.
const LegalCaseWithdrawalForm = ({
    errorFields,
    isSaving,
    onSubmit,
    onCancel,
}: LegalCaseWithdrawalFormProps) => {
    const form = useLegalCaseWithdrawalForm({ onSubmit });

    return (
        <div className="rounded-lg border border-gray-200 dark:border-slate-700 p-3 space-y-3">
            <p className="text-xs text-gray-500 dark:text-gray-400">
                Registrar levantamento (valor efetivamente transferido por alvará)
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <CurrencyInput
                    label="Valor levantado"
                    prefix="R$"
                    fractionDigits={2}
                    value={form.withdrawnAmount}
                    onChange={form.setWithdrawnAmount}
                    errorMessage={getErrorMessage(errorFields, 'withdrawnAmount')}
                />
                <DateField
                    label="Data do levantamento"
                    value={form.withdrawnAt}
                    onChange={form.setWithdrawnAt}
                    errorMessage={getErrorMessage(errorFields, 'withdrawnAt')}
                />
            </div>

            {residualWithdrawalErrors(errorFields).map((e) => (
                <div key={e.fieldName} className="flex items-center gap-2 text-sm text-red-700 dark:text-red-400">
                    <FiAlertTriangle size={14} />
                    <span>{e.message}</span>
                </div>
            ))}

            <div className="flex items-center justify-end gap-2">
                <button
                    type="button"
                    onClick={onCancel}
                    className="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    onClick={form.submit}
                    disabled={isSaving || !form.canSubmit}
                    className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium disabled:opacity-50"
                >
                    {isSaving ? 'Salvando...' : 'Registrar levantamento'}
                </button>
            </div>
        </div>
    );
};

export default LegalCaseWithdrawalForm;
